import { Pipe, PipeTransform } from '@angular/core';
import { formatHoursMinutesWithDuration } from '../utils/date-time-utils';

@Pipe({
    name: 'formatHoursMinutesWithDuration',
    standalone: true
})
export class FormatHoursMinutesWithDurationPipe implements PipeTransform {

  transform(value: string | null, duration: number): string {
    if (!value) {
      return '-';
    }

    return formatHoursMinutesWithDuration(value, duration);
  }

}
